import { Routes } from '@angular/router';
import { HeroComponent } from './hero/hero.component';
import { AboutPage } from './about/about.page';

export const routes: Routes = [
  {
    path: '',
    component: HeroComponent
  },
  {
    path: 'about',
    component: AboutPage,
  },
  {
    path: 'nps',
    loadChildren: () => import('./nps/nps.routes').then((m) => m.routes),
  },
  {
    path: 'political-donor-dashboard',
    loadChildren: () =>
      import('./political-donor-dashboard/political-donor-dashboard.routes').then(
        (m) => m.routes
      ),
  },
];
